export class VideoElementContainer {
    constructor(private _videoElement: HTMLVideoElement) {
    }

    private _containerElement: HTMLElement | null = null;

    get isAttached(): boolean {
        return Boolean(this._containerElement);
    }

    attach(containerElement: HTMLElement): void {
        if(!containerElement) {
            throw new Error('containerElement for video cannot be null or undefined');
        }

        if(this._containerElement) {
            this.detach();
        }

        this._containerElement = containerElement;

        this._containerElement.appendChild(this._videoElement);

    }

    public detach(): void {
        if(this._containerElement) {
            this._containerElement.removeChild(this._videoElement);
            this._containerElement = null;
        }
    }

    destroy(): void {
        this.detach();
        this._videoElement = null;
    }
}